import { legacyPlugins } from "/usr/src/app/node_modules/.pnpm/@unhead+vue@3.4.2_@oxc-project+types@0.153.0_@rsbuild+core@2.2.12_@rspack+core@2.2.8_@s_b253e5aeb8933de19124c23232555d18/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}